import React from "react"
import Layout from "../components/layout"
import PortfolioGallery from "../components/portfolio-gallery"

export default () => (
  <Layout>
    <PortfolioGallery />
  </Layout>
)
